(function(){
  if(window.GBP) return;
  var IMG_BOX='https://cdn.shopify.com/s/files/1/0197/0742/8926/files/Personalizedgiftbox.jpg?v=1702565795';
  var IMG_POUCH='https://cdn.shopify.com/s/files/1/0197/0742/8926/files/Personalizedleatherbag.jpg?v=1702565795';
  var IMG_NOTE='https://cdn.shopify.com/s/files/1/0197/0742/8926/files/Personal-note.jpg?v=1702565795';
  
  var IMG_BRACE=window.__GBP_CFG.img;
  if(!IMG_BRACE) IMG_BRACE='https://cdn.shopify.com/s/files/1/0197/0742/8926/files/free-bracelet-engraving-summer-sale.jpg?v=1785851620';
  var FIELDS=[
    {key:'Box side',      lab:'lab-box',   img:IMG_BOX,   size:40, color:'#e9e8e8', x:9,    y:51.5, rot:0, ls:0.4, depth:1.9, opacity:0.35, mw:85, align:'left',   valign:'middle', lines:1, minSize:24, max:40},
    {key:'Inside pouch',  lab:'lab-pouch', img:IMG_POUCH, size:61, color:'#7d7d7d', x:29.5, y:72,   rot:0, ls:1,   depth:1.5, opacity:0.4,  mw:39, align:'center', valign:'middle', lines:3, minSize:30, max:20},
    
    {key:'Personal note', lab:'lab-note',  img:IMG_NOTE,  size:20, color:'#111111', x:50,  y:50.5, rot:0, ls:0.5, depth:0.5, opacity:0.55,    mw:74, align:'center', valign:'middle', lines:10, minSize:13, max:800, emoji:'twemoji'},
    {key:'Free Bracelet side 1', lab:'lab-side1', img:IMG_BRACE, size:37, color:'#5c5c5c', x:50, y:49.5, rot:0, ls:1, depth:1, opacity:1, mw:19, align:'center', valign:'middle', lines:1, minSize:12, max:8, group:'brace'},
    {key:'Free Bracelet side 2', lab:'lab-side2', img:IMG_BRACE, size:37, color:'#5c5c5c', x:50, y:49.5, rot:0, ls:1, depth:1, opacity:1, mw:19, align:'center', valign:'middle', lines:1, minSize:12, max:8, group:'brace'},
    {key:'Free Bracelet side 3', lab:'lab-side3', img:IMG_BRACE, size:37, color:'#5c5c5c', x:50, y:49.5, rot:0, ls:1, depth:1, opacity:1, mw:19, align:'center', valign:'middle', lines:1, minSize:12, max:8, group:'brace'}
  ];
  
  var ENG_SET=window.__GBP_CFG.set;
  if(ENG_SET&&typeof ENG_SET==='object'){
    FIELDS.forEach(function(f){
      var o=ENG_SET[f.key];
      if(f.group!=='brace'||!o||typeof o!=='object') return;
      for(var k in o){ if(Object.prototype.hasOwnProperty.call(o,k)) f[k]=o[k]; }
    });
  }
  
  var I18N=document.getElementById('gbp-i18n');
  function T(k,vars,fallback){
    
    if(typeof vars==='string'){ fallback=vars; vars=null; }
    var e=I18N&&I18N.querySelector('[data-gbp-t="'+k+'"]');
    if(!e) return fallback||'';
    var v=(e.textContent||'').replace(/\s+/g,' ').trim();
    if(!vars) return v||fallback||'';
    
    var args=(e.getAttribute('data-args')||'').split(','), en=e.getAttribute('data-en')||v;
    var SLOT=/%[^%\s<>]{1,24}%/g;
    if((v.match(SLOT)||[]).length!==(en.match(SLOT)||[]).length) v=en;
    var i=0;
    
    return v.replace(SLOT,function(m){ var own=m.slice(1,-1), n=args[i++];
      if(own in vars) return String(vars[own]);
      return (n&&n in vars)?String(vars[n]):''; })||fallback||'';
  }
  
  function TH(k,fallback){
    var e=I18N&&I18N.querySelector('[data-gbp-t="'+k+'"]');
    var v=e?(e.innerHTML||'').trim():'';
    return v||fallback||'';
  }
  
  var STEPS=[
    {t:'s1t', i:'s1i', fields:[0]},
    {t:'s2t', i:'s2i', fields:[1]},
    {t:'s3t', i:'s3i', fields:[2]},
    {t:'s4t', i:'s4i', fields:[3,4,5], gift:true}
  ];
  
  var ENGRAVING_ON = window.__GBP_CFG.on;
  if(!ENGRAVING_ON) STEPS=STEPS.filter(function(st){ return !st.gift; });
  
  var ENG_SIDES=window.__GBP_CFG.sides;
  if(ENGRAVING_ON&&ENG_SIDES>=1&&ENG_SIDES<3) STEPS.forEach(function(st){ if(st.gift) st.fields=st.fields.slice(0,ENG_SIDES); });
  if(ENGRAVING_ON&&ENG_SIDES===1){ STEPS.forEach(function(st){ if(st.gift) st.i='s4i-one'; }); FIELDS[3].lab='lab-text'; }
  

  
  var GBP_OLD_PREFIX='Gift box – ';
  function attrKey(f){ return f.key==='Box side' ? 'Gift box side' : f.key; }
  function oldKey(f){ return GBP_OLD_PREFIX+f.key; }
  
  function isReal(v){ v=String(v==null?'':v).trim(); return !!v && !/^n\/a$/i.test(v); }
  function hasKey(o,k){ return Object.prototype.hasOwnProperty.call(o,k); }
  
  var STEPS_ALL=STEPS.slice(), NTF_BRACE={any:false, auto:false};
  function isBraceLine(it){ var q=(it&&it.properties)||{}; if(q._auto_gift) return 'auto';
    if(q._gift_choice && /bracelet|armband|bracelet/i.test(String(it.product_type||'')+' '+String(it.product_title||''))) return 'choice'; return ''; }
  function braceOf(cart){ var r={any:false, auto:false}; ((cart&&cart.items)||[]).forEach(function(it){ var k=isBraceLine(it); if(k){ r.any=true; if(k==='auto') r.auto=true; } }); return r; }
  function applySteps(withBrace){ STEPS = withBrace ? STEPS_ALL.slice() : STEPS_ALL.filter(function(st){ return !st.gift; });
    var te=document.getElementById('gbp-steptot'); if(te) te.textContent=STEPS.length; }
  applySteps(false);
  var totEl=document.getElementById('gbp-steptot');
  if(totEl) totEl.textContent=STEPS.length;
  var EDITKEYS=['size','minSize','color','x','y','rot','ls','depth','opacity','mw','align','valign','lines','max','skx','sky'];

  var qs=location.search;
  if(/[?&]gbp-edit=1/.test(qs)) localStorage.setItem('gbpEdit','1');
  if(/[?&]gbp-edit=0/.test(qs)) localStorage.removeItem('gbpEdit');
  
  if(/[?&]gbp-edit=reset/.test(qs)){ localStorage.removeItem('gbpOverrides'); }
  
  try{ localStorage.removeItem('gbpDiag'); }catch(e){}
  var EDIT=false; try{ EDIT=localStorage.getItem('gbpEdit')==='1'; }catch(e){}

  
  var GBP_BASE=JSON.stringify(FIELDS.map(function(f){ return EDITKEYS.map(function(k){ return f[k]; }); }));
  try{
    if(localStorage.getItem('gbpOverridesBase')!==GBP_BASE){
      localStorage.removeItem('gbpOverrides');
      localStorage.setItem('gbpOverridesBase',GBP_BASE);
    }
  }catch(e){}

  try{ var ov=JSON.parse(localStorage.getItem('gbpOverrides')||'{}'); FIELDS.forEach(function(f){ if(ov[f.key]) EDITKEYS.forEach(function(k){ if(ov[f.key][k]!=null) f[k]=ov[f.key][k]; }); }); }catch(e){}
  function saveOverrides(){ var o={}; FIELDS.forEach(function(f){ o[f.key]={}; EDITKEYS.forEach(function(k){ o[f.key][k]=f[k]; }); });
    localStorage.setItem('gbpOverrides',JSON.stringify(o));
    
    try{ localStorage.setItem('gbpOverridesBase',GBP_BASE); }catch(e){} }

  
  var vals={}, GBP_SAVED=null, GBP_ADOPTED=false;
  try{
    var _gbpRaw=JSON.parse(localStorage.getItem('gbpCustomer')||'{}');
    GBP_SAVED=(_gbpRaw && _gbpRaw.vals && typeof _gbpRaw.vals==='object')
      ? _gbpRaw : { token:null, at:0, vals:(_gbpRaw||{}) };
  }catch(e){ GBP_SAVED={ token:null, at:0, vals:{} }; }
  function adoptSaved(cart){
    if(GBP_ADOPTED) return; GBP_ADOPTED=true;
    if(!GBP_SAVED || !GBP_SAVED.vals) return;
    if(!cart || !cart.token || GBP_SAVED.token!==cart.token) return;
    
    var at=cart.attributes||{}, real=false;
    FIELDS.forEach(function(f){ if(isReal(at[attrKey(f)]) || isReal(at[oldKey(f)])) real=true; });
    if(!real) return;
    vals=GBP_SAVED.vals;
    FIELDS.forEach(function(f){ if(f._input && !f._input.value && vals[f.key]) f._input.value=vals[f.key]; });
  }
  fetch('/cart.js?_=' + Date.now(),{headers:{Accept:'application/json'},cache:'no-store'})
    .then(function(r){ return r.json(); }).then(adoptSaved)
    .catch(function(){ GBP_ADOPTED=true; });
  var imgs={}, active=0, step=0, showBounds=false;
  
  var caretField=null, caretPos=0, caretOn=true, caretTimer=null;
  function caretStart(f,inp){
    caretField=f; caretPos=inp.selectionStart==null?inp.value.length:inp.selectionStart;
    caretOn=true;
    if(caretTimer) clearInterval(caretTimer);
    
    caretTimer=setInterval(function(){ caretOn=!caretOn; render(); },530);
    render();
  }
  function caretMove(inp){
    if(!caretField) return;
    caretPos=inp.selectionStart==null?inp.value.length:inp.selectionStart;
    caretOn=true; render();
  }
  function caretStop(){
    caretField=null;
    if(caretTimer){ clearInterval(caretTimer); caretTimer=null; }
    render();
  }
  
  function loadImg(src){ if(imgs[src]) return; var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){imgs[src]=im; if(overlay&&overlay.classList.contains('gbp-open')) render();}; im.src=src; }
  
  var warmed=false;
  
  function loadFaces(){
    if(!document.fonts||!document.fonts.load) return Promise.resolve();
    return Promise.all([document.fonts.load('600 40px GBPMontserrat'),document.fonts.load('400 16px GBPMontserrat')]);
  }
  function facesOk(){
    try{ return !document.fonts||!document.fonts.check||(document.fonts.check('600 40px GBPMontserrat')&&document.fonts.check('400 16px GBPMontserrat')); }catch(e){ return true; }
  }
  
  
  var facesAsked=false;
  function warmFaces(){ if(facesAsked) return; facesAsked=true; loadFaces().then(null,function(){}); }
  function warm(){ if(warmed) return; warmed=true; FIELDS.forEach(function(f){ loadImg(f.img); (f.views||[]).forEach(function(v){ if(v&&v.img) loadImg(v.img); }); }); }
  
  var viewIdx=0, viewTimer=null;
  function viewOf(f){ if(!f.views||!f.views.length) return f; var v=f.views[viewIdx%f.views.length], o={}, k;
    for(k in f){ if(Object.prototype.hasOwnProperty.call(f,k)) o[k]=f[k]; }
    for(k in v){ if(Object.prototype.hasOwnProperty.call(v,k)) o[k]=v[k]; } return o; }
  
  var FADE=700, fadeSnap=null, fadeT0=0;
  
  function startViews(){ stopViews(); }
  function fadeTo(i){
    try{ fadeSnap=document.createElement('canvas'); fadeSnap.width=cv.width; fadeSnap.height=cv.height; fadeSnap.getContext('2d').drawImage(cv,0,0); }catch(e){ fadeSnap=null; }
    viewIdx=i; fadeT0=Date.now(); markViewThumbs();
    (function step(){ render(); if(fadeSnap) requestAnimationFrame(step); })(); }
  function markViewThumbs(){ var box=document.getElementById('gbp-vthumbs'); if(!box) return;
    [].forEach.call(box.children,function(b,i){ b.classList.toggle('is-on',i===viewIdx); b.setAttribute('aria-pressed',i===viewIdx?'true':'false'); }); }
  function buildViewThumbs(){ var box=document.getElementById('gbp-vthumbs'); if(!box) return;
    var f=FIELDS[active], v=(f&&f.views)||[];
    if(v.length<2||(stepsEl&&stepsEl.hidden)){ box.hidden=true; box.innerHTML=''; return; }
    if(viewIdx>=v.length) viewIdx=0;
    box.innerHTML=''; box.hidden=false;
    v.forEach(function(view,i){ var b=document.createElement('button'); b.type='button'; b.className='gbp-vthumb';
      var src=view.img||f.img; b.style.backgroundImage='url("'+src+(src.indexOf('?')<0?'?':'&')+'width=120")';
      b.setAttribute('aria-label',T('photo','Photo')+' '+(i+1));
      b.addEventListener('click',function(e){ e.stopPropagation(); if(i!==viewIdx) fadeTo(i); });
      box.appendChild(b); });
    markViewThumbs(); }
  function stopViews(){ if(viewTimer){ clearInterval(viewTimer); viewTimer=null; } fadeSnap=null; }
  
  var renderBase=render;
  render=function(){ renderBase(); if(!fadeSnap) return; var t=(Date.now()-fadeT0)/FADE;
    if(t>=1){ fadeSnap=null; return; }
    ctx.save(); ctx.globalAlpha=1-t; ctx.drawImage(fadeSnap,0,0); ctx.restore(); };

  var modalEl=document.querySelector('.gbp-modal');
  var cv=document.getElementById('gbp-canvas'), ctx=cv.getContext('2d');
  function clamp01(v){ return Math.max(0,Math.min(1,Math.round(v*1000)/1000)); }
  function hexRGB(h){
    h=String(h||'#000000').replace('#','');
    if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return parseInt(h.slice(0,2),16)+','+parseInt(h.slice(2,4),16)+','+parseInt(h.slice(4,6),16);
  }
  
  var TWEMOJI_BASE='https://cdn.jsdelivr.net/gh/jdecked/twemoji@15.1.0/assets/72x72/';
  var EMOJI_RE=null;
  try{ EMOJI_RE=new RegExp('\\p{RI}\\p{RI}|[#*0-9]\\uFE0F?\\u20E3|\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier})?(?:\\u200D\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier})?)*','gu'); }catch(e){ EMOJI_RE=null; }
  var emojiImgs={};
  
  function twemojiCode(e){ var s=e.indexOf('‍')<0?e.replace(/️/g,''):e, out=[];
    for(var i=0;i<s.length;){ var cp=s.codePointAt(i); out.push(cp.toString(16)); i+=cp>0xffff?2:1; } return out.join('-'); }
  function emojiImg(e){ var c=twemojiCode(e), im=emojiImgs[c];
    if(!im){ im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){ im._ok=true; render(); };
      im.onerror=function(){ im._bad=true; }; im.src=TWEMOJI_BASE+c+'.png'; emojiImgs[c]=im; }
    return im._ok?im:null; }
  
  function segs(str,emo){ str=String(str); if(!emo||!EMOJI_RE) return [{t:str}]; var out=[], last=0, m; EMOJI_RE.lastIndex=0;
    while((m=EMOJI_RE.exec(str))){ if(m.index>last) out.push({t:str.slice(last,m.index)}); out.push({e:m[0]}); last=m.index+m[0].length; }
    if(last<str.length) out.push({t:str.slice(last)}); return out; }
  
  function runW(str,s,emo){ var w=0; segs(str,emo).forEach(function(g){ w+=g.e?s:ctx.measureText(g.t).width; }); return w; }
  function wrapText(text,maxW,s,emo){ ctx.font='600 '+s+'px GBPMontserrat, sans-serif'; var out=[]; String(text).split('\n').forEach(function(p){ var ws=p.split(' '), cur=''; for(var i=0;i<ws.length;i++){ var t=cur?cur+' '+ws[i]:ws[i]; if(runW(t,s,emo)>maxW&&cur){out.push(cur);cur=ws[i];}else cur=t; } out.push(cur); }); return out; }
  
  function fitsArea(f,text){
    if(!text) return true;
    var maxW=cv.width*(f.mw/100), minS=f.minSize||8, emo=f.emoji==='twemoji';
    
    if('letterSpacing' in ctx) ctx.letterSpacing=(f.ls||0)+'px';
    if(f.lines>1){
      var ls=wrapText(text,maxW,minS,emo);
      if(ls.length>f.lines) return false;
      
      for(var i=0;i<ls.length;i++){ if(runW(ls[i],minS,emo)>maxW) return false; }
      return true;
    }
    ctx.font='600 '+minS+'px GBPMontserrat, sans-serif';
    return runW(text,minS,emo)<=maxW;
  }

  
  function fitLines(f,text){
    var emo=f.emoji==='twemoji', maxW=cv.width*(f.mw/100), minS=f.minSize||8, s=f.size, lines;
    if('letterSpacing' in ctx) ctx.letterSpacing=(f.ls||0)+'px';
    if(f.lines>1){ while(true){ lines=wrapText(text,maxW,s,emo);
      var wide=false;
      for(var li=0;li<lines.length;li++){ if(runW(lines[li],s,emo)>maxW){ wide=true; break; } }
      if((lines.length<=f.lines&&!wide)||s<=minS) break; s-=1; } }
    else { ctx.font='600 '+s+'px GBPMontserrat, sans-serif'; while(runW(text,s,emo)>maxW&&s>minS){ s-=1; ctx.font='600 '+s+'px GBPMontserrat, sans-serif'; } lines=[text]; }
    ctx.font='600 '+s+'px GBPMontserrat, sans-serif';
    return {s:s, lines:lines, maxW:maxW, emo:emo};
  }

  function render(){
    var f=viewOf(FIELDS[active]), im=imgs[f.img], W=cv.width,H=cv.height;
    ctx.clearRect(0,0,W,H); ctx.fillStyle='#ececef'; ctx.fillRect(0,0,W,H); if(im) ctx.drawImage(im,0,0,W,H);
    var multi=f.lines>1, raw=vals[f.key]||'', ph=!raw,
        text=raw||(multi?T('ph-canvas-note','Your note…'):T('ph-canvas-text','Your text'));
    var fit=fitLines(f,text), maxW=fit.maxW, s=fit.s, lines=fit.lines, emo=fit.emo;
    var n=lines.length, lh=s*1.3, px=W*f.x/100, py=H*f.y/100;
    var startY=f.valign==='top'?0:(f.valign==='bottom'?-(n-1)*lh:-(n-1)*lh/2);
    ctx.save(); ctx.translate(px,py); ctx.rotate(f.rot*Math.PI/180);
    if(f.skx||f.sky) ctx.transform(1,Math.tan((f.sky||0)*Math.PI/180),Math.tan((f.skx||0)*Math.PI/180),1,0,0);
    ctx.textAlign=f.align; ctx.textBaseline='middle';
    
    var op=(f.opacity==null?1:f.opacity);
    var alpha=op, d=f.depth||0;
    
    var col=hexRGB(f.color);
    var aFill=clamp01(alpha), aDark=clamp01(0.5*d*alpha), aLite=clamp01(0.13*d*alpha),
        aShad=clamp01(0.35*d*alpha);
    ctx.globalAlpha=1;
    
    function ink(str,x,yy){
      if(d>0){ ctx.fillStyle='rgba(0,0,0,'+aDark+')'; ctx.fillText(str,x,yy-1.1*d);
               ctx.fillStyle='rgba(255,255,255,'+aLite+')'; ctx.fillText(str,x,yy+1.3*d); }
      ctx.shadowColor='rgba(0,0,0,'+aShad+')'; ctx.shadowBlur=1.4*d;
      ctx.fillStyle='rgba('+col+','+aFill+')'; ctx.fillText(str,x,yy); ctx.shadowBlur=0;
    }
    lines.forEach(function(ln,i){ var yy=startY+i*lh;
      if(!emo){ ink(ln,0,yy); return; }
      
      var lw=runW(ln,s,true), x=f.align==='left'?0:(f.align==='right'?-lw:-lw/2);
      ctx.textAlign='left';
      segs(ln,true).forEach(function(g){
        if(g.t!=null){ ink(g.t,x,yy); x+=ctx.measureText(g.t).width; return; }
        var ei=emojiImg(g.e);
        if(ei) ctx.drawImage(ei,x,yy-s*0.5,s,s);
        else ink(g.e,x,yy);                    // image not loaded (yet): the character, as before
        x+=s;
      });
      ctx.textAlign=f.align;
    });
    
    if(caretField===f && !ph){
      var before=raw.slice(0,Math.min(caretPos,raw.length));
      
      var ci=0, cbefore=before;
      if(multi){
        var consumed=0;
        for(var q=0;q<lines.length;q++){
          var seg=lines[q];
          
          var end=consumed+seg.length+(q<lines.length-1?1:0);
          if(before.length<=end||q===lines.length-1){ ci=q; cbefore=before.slice(consumed); break; }
          consumed=end;
        }
      }
      var lineTxt=lines[ci]||'';
      var wAll=runW(lineTxt,s,emo), wPre=runW(cbefore,s,emo);
      
      var cx=f.align==='left'?wPre:(f.align==='right'?wPre-wAll:wPre-wAll/2);
      var cy=startY+ci*lh;
      if(caretOn){
        ctx.save();
        ctx.globalAlpha=1;
        ctx.fillStyle='rgba('+col+','+clamp01(Math.max(alpha,0.65))+')';
        ctx.fillRect(cx, cy-s*0.42, Math.max(1.2,s*0.045), s*0.84);
        ctx.restore();
      }
    }
    if(EDIT&&showBounds){ ctx.strokeStyle='rgba(80,170,255,.9)'; ctx.setLineDash([9,6]); ctx.lineWidth=2; var bx=f.align==='left'?0:(f.align==='right'?-maxW:-maxW/2); var glh=f.size*1.3, bH=Math.max(1,f.lines)*glh, bT=f.valign==='top'?-glh/2:(f.valign==='bottom'?-bH+glh/2:-bH/2); ctx.strokeRect(bx,bT,maxW,bH); }
    ctx.restore();
  }


  
  function isMobileLayout(){
    try{ return window.matchMedia('(max-width:760px)').matches; }catch(e){ return false; }
  }
  var typeBar=document.getElementById('gbp-typebar');
  var typeLbl=document.getElementById('gbp-typebar-l');
  
  function charsLeft(f,len){
    var n=Math.max(0,f.max-len);
    
    return n===1 ? T('char-left',{n:n},'1 character left') : T('chars-left',{n:n},n+' characters left');
  }
  
  function fieldLabel(f){ return T(f.lab, f.key.replace('Free Bracelet side','Side')); }
  
  function applyStrings(){
    FIELDS.forEach(function(f){
      if(f._lab){
        if(f._lab.firstChild) f._lab.firstChild.textContent=fieldLabel(f);
        var c=f._lab.querySelector('.gbp-count');
        if(c) c.textContent=charsLeft(f,(vals[f.key]||'').length);
      }
      if(f._input) f._input.placeholder=(f.lines>1)?T('ph-note','Your personal note…'):T('ph-text','Add text');
    });
  }
  function typeBarText(f,txt,full){
    if(!typeLbl) return;
    
    typeLbl.textContent=fieldLabel(f)+', '+txt;
    typeLbl.classList.toggle('is-full',!!full);
  }
  document.getElementById('gbp-typedone').addEventListener('click',function(){
    var a=document.activeElement;
    if(a&&a.blur) a.blur();                      // dismisses the keyboard; blur handler restores the form
  });

  function makeInput(f,idx){ var multi=f.lines>1, inp=multi?document.createElement('textarea'):document.createElement('input');
    
    if(multi){ inp.rows=Math.min(f.lines,4); } else { inp.type='text'; }
    inp.maxLength=f.max; inp.placeholder=multi?T('ph-note','Your personal note…'):T('ph-text','Add text'); inp.value=vals[f.key]||'';
    
    inp.setAttribute('autocomplete','off');
    inp.setAttribute('autocorrect','off');
    inp.setAttribute('autocapitalize','sentences');
    inp.setAttribute('spellcheck','false');
    inp.setAttribute('data-form-type','other');   // 1Password/Dashlane opt-out
    inp.name='gbp-f'+idx;
    inp.id='gbp-f'+idx;
    inp.addEventListener('blur',function(){
      
      setTimeout(function(){
        var a=document.activeElement;
        if(!a||(a.tagName!=='INPUT'&&a.tagName!=='TEXTAREA')) modalEl.classList.remove('gbp-typing');
      },120);
    });
    inp.addEventListener('focus',function(){ setActive(idx); modalEl.classList.add('gbp-typing');
      typeBarText(f,charsLeft(f,inp.value.length),false);
      caretStart(f,inp);
    });
    
    ['keyup','click','select'].forEach(function(ev){
      inp.addEventListener(ev,function(){ if(caretField===f) caretMove(inp); });
    });
    inp.addEventListener('blur',function(){ if(caretField===f) caretStop(); });
    inp.addEventListener('input',function(){
      var cnt=f._lab.querySelector('.gbp-count');
      
      var prev=vals[f.key]||'', next=inp.value, grew=next.length>prev.length;
      if(grew && !fitsArea(f,next)){
        var caret=inp.selectionStart;
        inp.value=prev;
        
        try{ var back=Math.max(0,caret-(next.length-prev.length)); inp.setSelectionRange(back,back); }catch(e){}
        cnt.textContent=T('no-space','No space left');
        typeBarText(f,T('no-space','No space left'),true);
        cnt.classList.add('is-full');
        clearTimeout(f._fullT);
        f._fullT=setTimeout(function(){ cnt.classList.remove('is-full');
          cnt.textContent=charsLeft(f,(vals[f.key]||'').length); },1400);
        return;
      }
      vals[f.key]=next;
      if(caretField===f) caretPos=inp.selectionStart==null?next.length:inp.selectionStart;
      cnt.classList.remove('is-full');
      cnt.textContent=charsLeft(f,next.length);
      typeBarText(f,charsLeft(f,next.length),false);
      if(active===idx) render();
    });
    return inp; }
  function rebuildInput(idx){ var f=FIELDS[idx], ni=makeInput(f,idx); f._row.replaceChild(ni,f._input); f._input=ni; f._lab.querySelector('.gbp-count').textContent=charsLeft(f,(vals[f.key]||'').length); }
  FIELDS.forEach(function(f,idx){ var row=document.createElement('div'); row.className='gbp-field'; var lab=document.createElement('div'); lab.className='gbp-flabel';
    lab.innerHTML='<span></span><span class="gbp-count"></span>';
    lab.firstChild.textContent=fieldLabel(f);
    lab.lastChild.textContent=charsLeft(f,(vals[f.key]||'').length);
    f._row=row; f._lab=lab; row.appendChild(lab); var inp=makeInput(f,idx); f._input=inp; row.appendChild(inp); });
  function setActive(idx){ active=idx; if(EDIT) syncEdit(); render(); }

  
  var startEl=document.getElementById('gbp-start'), stepsEl=document.getElementById('gbp-steps'), stepFields=document.getElementById('gbp-stepfields');
  var backBtn=document.getElementById('gbp-back'), nextBtn=document.getElementById('gbp-next');
  function buildDots(){ var d=document.getElementById('gbp-dots'); d.innerHTML=''; STEPS.forEach(function(_,i){ var x=document.createElement('div'); x.className='gbp-dot'+(i<=step?' on':''); d.appendChild(x); }); }
  function silence(v){ if(!v) return; try{ v.defaultMuted=true; v.muted=true; v.volume=0; }catch(e){} }
  function toggleMedia(vid){
    var v=document.getElementById('gbp-startvid'), c=document.getElementById('gbp-canvas');
    if(v)v.style.display=vid?'block':'none'; if(c)c.style.display=vid?'none':'block';
    if(!v) return;
    silence(v);
    try{
      if(vid){ v.play().catch(function(){}); }
      
      else { v.pause(); try{ v.currentTime=0; }catch(e2){} }
    }catch(e){}
  }
  var sumEl=document.getElementById('gbp-summary');
  
  function liveFields(){ var live={}; STEPS.forEach(function(st){ st.fields.forEach(function(i){ live[i]=1; }); }); return live; }
  function hasVals(){
    var live=liveFields();
    for(var i=0;i<FIELDS.length;i++){ if(live[i] && (vals[FIELDS[i].key]||'').trim()) return true; }
    return false;
  }
  function showSummary(){ var vt=document.getElementById('gbp-vthumbs'); if(vt) vt.hidden=true;
    if(modalEl) modalEl.classList.remove('gbp-intro');
    var list=document.getElementById('gbp-sumlist');
    list.innerHTML='';
    
    var SHORT={'Box side':T('short-box','Box side'),'Inside pouch':T('short-pouch','Pouch'),
               'Personal note':T('short-note','Note'),
               'Free Bracelet side 1':T('short-b1','Bracelet 1'),
               'Free Bracelet side 2':T('short-b2','Bracelet 2'),
               'Free Bracelet side 3':T('short-b3','Bracelet 3')};
    
    var live=liveFields();
    FIELDS.forEach(function(f, idx){
      if(!live[idx]) return;
      var v=(vals[f.key]||'').trim();
      
      var row=document.createElement('button');
      row.type='button';
      row.className='gbp-sum-row';
      row.setAttribute('data-gbp-preview', idx);
      var dt=document.createElement('dt'); dt.textContent=(SHORT[f.key]||f.key)+':';
      var dd=document.createElement('dd');
      dd.textContent = v || T('none','Not personalised');   // textContent, never innerHTML
      if(!v) row.classList.add('is-empty');
      
      var pen=document.createElement('span');
      pen.className='gbp-sum-pen';
      pen.setAttribute('role','button');
      pen.setAttribute('tabindex','0');
      pen.setAttribute('aria-label', v
        ? T('edit-field',{field:(SHORT[f.key]||f.key)},'Edit '+(SHORT[f.key]||f.key))
        : T('add-field', {field:(SHORT[f.key]||f.key)},'Add ' +(SHORT[f.key]||f.key)));
      pen.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"'
        + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
        + '<path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z"/><path d="M14.5 6.5l3 3"/></svg>';
      var goEdit=function(ev){
        ev.stopPropagation();          // the row itself only previews; the pencil edits
        ev.preventDefault();
        var si=0;
        for(var k=0;k<STEPS.length;k++){ if(STEPS[k].fields.indexOf(idx)!==-1){ si=k; break; } }
        
        editOne = true;
        goStep(si);
      };
      pen.addEventListener('click', goEdit);
      pen.addEventListener('keydown', function(ev){ if(ev.key==='Enter'||ev.key===' ') goEdit(ev); });
      row.appendChild(dt); row.appendChild(dd); row.appendChild(pen); list.appendChild(row);
      
      row.addEventListener('click', function(){
        active=idx; render();
        [].forEach.call(list.children, function(el){ el.classList.remove('is-on'); });
        row.classList.add('is-on');
      });
    });
    startEl.hidden=true; stepsEl.hidden=true; sumEl.hidden=false; askRemove(false);
    
    toggleMedia(false);
    var firstFilled=-1;
    for(var i=0;i<FIELDS.length;i++){ if(live[i] && (vals[FIELDS[i].key]||'').trim()){ firstFilled=i; break; } }
    if(firstFilled<0){ for(var fi=0;fi<FIELDS.length;fi++){ if(live[fi]){ firstFilled=fi; break; } } }
    if(firstFilled<0) firstFilled=0;
    
    var onRow=list.querySelector('[data-gbp-preview="'+firstFilled+'"]');
    if(onRow) onRow.classList.add('is-on'); else if(list.firstChild) list.firstChild.classList.add('is-on');
    active=firstFilled; render();
  }
  var confirmEl=document.getElementById('gbp-sum-confirm');
  
  var confirmHome = confirmEl.parentElement;
  function askRemove(show){
    
    var host = document.querySelector(".gbp-overlay") || document.body;
    if (show) {
      if (confirmEl.parentElement !== host) host.appendChild(confirmEl);
    } else if (confirmHome && confirmEl.parentElement !== confirmHome) {
      confirmHome.appendChild(confirmEl);
    }
    confirmEl.hidden=!show;
  }
  function clearAll(){
    var btn=document.getElementById('gbp-sum-yes');
    btn.disabled=true; btn.textContent=T('removing','Removing…');
    
    var attrs={};
    FIELDS.forEach(function(f){ attrs[attrKey(f)]=GBP_NA; attrs[oldKey(f)]=''; });   // '' removes the old name
    attrs[GBP_LAYOUT_KEY]=GBP_NA;               // no note, no layout to print it from
    attrs[GBP_LAYOUT_OLD]='';
    var finish=function(){
      vals={};
      try{ localStorage.removeItem('gbpCustomer'); }catch(e){}
      FIELDS.forEach(function(f){ if(f._input){ f._input.value=''; }
        if(f._lab){ var cnt=f._lab.querySelector('.gbp-count'); if(cnt) cnt.textContent=charsLeft(f,0); } });
      btn.disabled=false; btn.textContent=T('yes-remove','Yes, remove');
      askRemove(false);
      updateDrawer(false);
      
      close(); toast(T('removed','Personalisation removed \u2713'));
      returnToCart();
      document.dispatchEvent(new CustomEvent('gbp:cleared'));
    };
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:attrs})})
      .then(function(r){ if(!r.ok) throw new Error('cart update '+r.status); return r.json(); })
      .then(finish)
      .catch(function(){ btn.disabled=false; btn.textContent=T('yes-remove','Yes, remove');
        toast(T('err-remove','Could not remove \u2014 please try again')); });
  }
  document.getElementById('gbp-sum-back').addEventListener('click',function(){
    close();
    returnToCart();
  });
  document.getElementById('gbp-sum-continue').addEventListener('click',function(){
    close();
    
    if(location.pathname.indexOf('/products/')<0) return;
    var atc=[].slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]'))
      .filter(function(b){ return b.getClientRects().length; })[0];
    if(atc){ try{ atc.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){ atc.scrollIntoView(); } }
  });
  document.getElementById('gbp-sum-clear').addEventListener('click',function(){ askRemove(true); });
  document.getElementById('gbp-sum-no').addEventListener('click',function(){ askRemove(false); });
  confirmEl.addEventListener('click',function(ev){ if(ev.target===confirmEl) askRemove(false); });
  document.getElementById('gbp-sum-yes').addEventListener('click',clearAll);

  
  function showStart(){ var vt=document.getElementById('gbp-vthumbs'); if(vt) vt.hidden=true; if(modalEl) modalEl.classList.add('gbp-intro');
    startEl.hidden=false; stepsEl.hidden=true; if(sumEl) sumEl.hidden=true; active=0; toggleMedia(true); if(EDIT) syncEdit(); render();
    
    var bt=document.getElementById('gbp-begin');
    if(bt){ void bt.offsetHeight; bt.classList.add('gbp-repaint'); requestAnimationFrame(function(){ bt.classList.remove('gbp-repaint'); }); } }
  
  var editOne = false;
  
  var stepSnapshot = {};
  function restoreStepSnapshot(){
    STEPS[step].fields.forEach(function(fi){
      var f=FIELDS[fi];
      if(!(f.key in stepSnapshot)) return;
      vals[f.key]=stepSnapshot[f.key];
      if(f._input) f._input.value=vals[f.key]||'';
      if(f._lab){ var c=f._lab.querySelector('.gbp-count'); if(c) c.textContent=charsLeft(f,(vals[f.key]||'').length); }
    });
    render();
  }
  function goStep(i){ if(modalEl) modalEl.classList.remove('gbp-intro');
    step=i; startEl.hidden=true; if(sumEl) sumEl.hidden=true; stepsEl.hidden=false; toggleMedia(false); stepFields.innerHTML='';
    stepSnapshot={}; STEPS[i].fields.forEach(function(fi){ stepSnapshot[FIELDS[fi].key]=vals[FIELDS[fi].key]; });
    STEPS[i].fields.forEach(function(fi){ stepFields.appendChild(FIELDS[fi]._row); });
    var gsn=document.getElementById('gbp-stepno'); if(gsn) gsn.textContent=(i+1); var gst=document.getElementById('gbp-steptitle'); if(gst) gst.textContent=T(STEPS[i].t); var gsi=document.getElementById('gbp-stepinstr'); if(gsi) gsi.textContent=T(STEPS[i].i);
    
    nextBtn.textContent = (editOne || i===STEPS.length-1) ? T('save','Save personalisation') : T('next','Next \u2192');
    buildDots(); setActive(STEPS[i].fields[0]); buildViewThumbs();
    
    var panelEl=document.querySelector('.gbp-panel');
    if(panelEl) panelEl.scrollTop=0;
    if(modalEl) modalEl.scrollTop=0;

    var fi=stepFields.querySelector('input,textarea');
    
    if(fi&&!isMobileLayout()) setTimeout(function(){
      try{ fi.focus({preventScroll:true}); }catch(e){ fi.focus(); }
    },40);
    // The full gift box flow shows the same required no-refund checkbox on the free bracelet step (Kai, 27 Oct 2026:
    // "we also need to show that checkmark in the giftbox rout"); the cart's "Engrave here" route sets it in open().
    if(!braceOnly){ var bnS=document.getElementById('gbp-brace-note'); if(bnS){ bnS.style.display=(i===braceStepIdx())?'flex':'none'; bnS.style.color='#6f6961'; } }
    boxNotePaint();
  }
  /* Gift box / pouch no-refund checkbox (Kai, 3 Nov): shown on the step that saves once either has text; required to save. */
  function boxText(){ var t=''; FIELDS.forEach(function(f){ if(f.key==='Box side'||f.key==='Inside pouch'){ var v=((f._input&&f._input.value)||'').trim(); if(v&&v!==GBP_NA) t+=v; } }); return t; }
  function boxNotePaint(){ var n=document.getElementById('gbp-box-note'); if(!n) return; var on=!braceOnly && !!boxText() && (editOne || step===STEPS.length-1); n.style.display=on?'flex':'none'; if(!on){ n.style.color='#6f6961'; } }
  function boxAckMissing(){ var a=document.getElementById('gbp-box-ack'); return !!(a && boxText() && !a.checked); }
  document.addEventListener('input',function(e){ if(e.target && e.target.closest && e.target.closest('#gbp-stepfields')) boxNotePaint(); });
  function braceStepIdx(){ for(var i=0;i<STEPS.length;i++){ if(STEPS[i].fields.some(function(fi){ return FIELDS[fi].key==='Free Bracelet side 1'; })) return i; } return -1; }
  function braceText(){ var t=''; FIELDS.forEach(function(f){ if(f.key==='Free Bracelet side 1') t=((f._input&&f._input.value)||'').trim(); }); return t===GBP_NA?'':t; }
  function braceAckMissing(){ var a=document.getElementById('gbp-brace-ack'); return !!(a && braceText() && !a.checked); }
  function braceAckAsk(){ var bi=braceStepIdx(); if(step!==bi) goStep(bi); var bN=document.getElementById('gbp-brace-note'); if(bN) bN.style.color='#b3261e'; var a=document.getElementById('gbp-brace-ack'); if(a) a.focus(); }
  document.getElementById('gbp-begin').addEventListener('click',function(){ editOne=false; goStep(0); });
  backBtn.addEventListener('click',function(){
    
    restoreStepSnapshot();
    if(braceOnly){ braceOnly=false; editOne=false; close(); return; }
    if(editOne){ editOne=false; showSummary(); return; }
    if(step>0) goStep(step-1); else if(hasVals()) showSummary(); else showStart();
  });
  /* Skip (Kai, 2 Nov): this step's text is emptied, then the same path as Next, so the last step still saves */
  var skipBtn=document.getElementById('gbp-skip');
  if(skipBtn) skipBtn.addEventListener('click',function(){
    STEPS[step].fields.forEach(function(fi){ var inp=FIELDS[fi]._input; if(inp && inp.value){ inp.value=''; inp.dispatchEvent(new Event('input',{bubbles:true})); } });
    var sa=document.getElementById('gbp-brace-ack'); if(sa) sa.checked=false;
    nextBtn.click();
  });
  nextBtn.addEventListener('click',function(){
    if(braceOnly){
      var bAck=document.getElementById('gbp-brace-ack'), bIn=document.querySelector('#gbp-stepfields input');
      if(bAck && bIn && bIn.value.trim() && !bAck.checked){ var bN=document.getElementById('gbp-brace-note'); if(bN){ bN.style.color='#b3261e'; } bAck.focus(); return; }
      NTF_ACK = !!(bAck && bAck.checked);
      braceOnly=false; editOne=false; save(); return; }
    var bi=braceStepIdx();
    if(bi>-1 && (step===bi || (!editOne && step===STEPS.length-1)) && braceAckMissing()){ braceAckAsk(); return; }
    if(step===bi){ var bA=document.getElementById('gbp-brace-ack'); NTF_ACK=!!(bA && bA.checked && braceText()); }
    if((editOne || step===STEPS.length-1) && boxAckMissing()){ boxNotePaint(); var xN=document.getElementById('gbp-box-note'); if(xN) xN.style.color='#b3261e'; var xA=document.getElementById('gbp-box-ack'); if(xA) xA.focus(); return; }
    if(editOne){ editOne=false; save(true); return; }
    if(step<STEPS.length-1) goStep(step+1); else save();
  });

  
  function ctaCopy(row,k,html,fb){
    var e=row.querySelector('[data-gbp-cta="'+k+'"]');
    if(!e) return fb;
    var v=(html?(e.innerHTML||''):(e.textContent||'')).replace(/\s+/g,' ').trim();
    return v||fb;
  }
  
  function updateDrawer(done){
    var rows=document.querySelectorAll('.gbp-cta');
    for(var i=0;i<rows.length;i++){
      var row=rows[i];
      row.classList.toggle('is-done',!!done);
      var t=row.querySelector('.gbp-cta-title');
      if(t){
        var title=ctaCopy(row,done?'title-done':'title-idle',false,done?'Gift box personalised \u2713':'Luxury gift box included');
        var n=t.firstChild;
        if(n && n.nodeType===3) n.nodeValue=title+' ';
        else t.insertBefore(document.createTextNode(title+' '),t.firstChild);
      }
      var sub=row.querySelector('.gbp-cta-sub');
      
      if(sub) sub.innerHTML=ctaCopy(row,done?'sub-done':'sub-idle',true,done?'Includes your personalisations.':'<span class="gbp-cta-free">Free</span> on every order. <u class="gbp-cta-link">Personalise it now.</u>');
    }
  }
  function toast(m){ var t=document.getElementById('gbp-toast'); t.textContent=m; t.classList.add('gbp-show'); setTimeout(function(){t.classList.remove('gbp-show');},2600); }
  
  var GBP_NA = 'N/A';
  var NTF_ACK = false;   // the free bracelet's no-refund checkbox, read when the line property is written

  
  var GBP_LAYOUT_KEY = '_Personal note layout';
  var GBP_LAYOUT_OLD = '_'+GBP_OLD_PREFIX+'Personal note layout';   // until 2 Oct 2026; cleared on every write
  var GBP_MM_PER_PX = 0.2351;   // the printed 190 mm card spans 808.3 of the preview's 1000 units

  

  
  function gbpCodePoints(s){
    var out=[], i=0, c, d; s=String(s);
    while(i<s.length){
      c=s.charCodeAt(i);
      if(c>=0xD800 && c<=0xDBFF && i+1<s.length){ d=s.charCodeAt(i+1);
        if(d>=0xDC00 && d<=0xDFFF){ out.push(s.substr(i,2)); i+=2; continue; } }
      out.push(s.charAt(i)); i++;
    }
    return out;
  }
  
  function gbpRebuildLines(text, breaks){
    var cps=gbpCodePoints(text), i, b;
    for(i=0;i<breaks.length;i++){ b=breaks[i];
      if(Math.floor(b)!==b || b<=0 || b>=cps.length) return null;
      if(i>0 && b<=breaks[i-1]) return null;
      if(cps[b]==='\n' || cps[b-1]==='\n') return null; }
    var rows=[], row='', next=0;
    for(i=0;i<cps.length;i++){
      if(next<breaks.length && breaks[next]===i){ rows.push(row.replace(/ +$/,'')); row=''; next++; }
      if(cps[i]==='\n'){ rows.push(row); row=''; } else row+=cps[i];
    }
    rows.push(row);
    return rows;
  }
  
  function gbpBreaks(text, lines){
    var paras=String(text).split('\n'), idx=0, breaks=[], base=0, i, p, used, line;
    for(i=0;i<paras.length;i++){
      p=paras[i];
      if(idx>=lines.length) return null;
      line=lines[idx++];
      if(p.substr(0,line.length)!==line) return null;
      used=line.length;
      while(used<p.length){
        if(p.charAt(used)!==' ' || idx>=lines.length) return null;
        line=lines[idx++];
        if(p.substr(used+1,line.length)!==line) return null;
        breaks.push(base+gbpCodePoints(p.substr(0,used+1)).length);
        used+=1+line.length;
      }
      base+=gbpCodePoints(p).length+1;          // this paragraph and its "\n"
    }
    return idx===lines.length ? breaks : null;
  }
  
  function gbpNoteCode(text, lines, size, spacing, twemoji, sha1){
    if(!sha1 || !/^[0-9a-f]{40}$/.test(sha1)) return null;
    if(Math.floor(size)!==size || size<13 || size>20) return null;
    if(spacing!==0 && spacing!==0.5) return null;
    if(!lines || lines.length>64 || String(text).indexOf('\r')>=0) return null;
    var breaks=gbpBreaks(text, lines);
    if(!breaks) return null;
    var rb=gbpRebuildLines(text, breaks);
    if(!rb || rb.length!==lines.length) return null;
    for(var i=0;i<rb.length;i++){ if(rb[i]!==lines[i]) return null; }
    return '2|a|'+size+'|'+breaks.join(',')+'|'+(twemoji?'t':'s')+(spacing?'l':'')+'|'+sha1.slice(0,8);
  }

  
  var GBP_FONT_600 = window.__GBP_CFG.font;
  function sha1Hex(str){
    if(!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.resolve(null);
    return crypto.subtle.digest('SHA-1', new TextEncoder().encode(str)).then(function(b){
      return Array.prototype.map.call(new Uint8Array(b), function(x){ return ('0'+x.toString(16)).slice(-2); }).join('');
    }, function(){ return null; });
  }
  
  function noteLayout(text){
    var f=null; FIELDS.forEach(function(x){ if(x.key==='Personal note') f=x; });
    if(!f || !text) return Promise.resolve(GBP_NA);
    var r=fitLines(f,text), lh=r.s*1.3, w=0;
    r.lines.forEach(function(l){ w=Math.max(w, runW(l,r.s,r.emo)); });
    
    var op=(f.opacity==null?1:f.opacity), hex=String(f.color||'#111111').replace('#','');
    if(hex.length===3) hex=hex.replace(/(.)/g,'$1$1');
    var ink='#'+[0,2,4].map(function(i){ var c=parseInt(hex.substr(i,2),16);
      return ('0'+Math.round(c*op+255*(1-op)).toString(16)).slice(-2); }).join('');
    var spacing=('letterSpacing' in ctx)?(f.ls||0):0, twemoji=!!(r.emo && EMOJI_RE);
    var spec={ v:1, lines:r.lines, font_px:r.s, line_height_px:Math.round(lh*100)/100, ink:ink,
      letter_spacing_px:spacing,
      font:{ family:'Montserrat', weight:600, url:GBP_FONT_600 },
      emoji:twemoji?'twemoji':'system', align:f.align||'center',
      mm_per_px:GBP_MM_PER_PX, block_w_px:Math.round(w*10)/10,
      block_h_px:Math.round(r.lines.length*lh*10)/10 };
    var profileA=(ink==='#7c7c7c' && (f.align||'center')==='center' && GBP_MM_PER_PX===0.2351);
    render();                                   // fitLines left the note's font on the canvas
    return sha1Hex(text).then(function(h){
      var code=null;
      try{ if(profileA) code=gbpNoteCode(text, r.lines, r.s, spacing, twemoji, h); }catch(e){ code=null; }
      if(code) return code;
      if(h) spec.text_sha1=h;
      return JSON.stringify(spec);
    });
  }

  
  var seedInFlight=null, savedThisPage=false;
  
  var NTF_PENDING_KEY='ntf_brace_pending';
  function ntfApplyPending(cart){
    var pend=null; try{ pend=JSON.parse(localStorage.getItem(NTF_PENDING_KEY)||'null'); }catch(e){}
    if(!pend||!pend.t) return;
    var line=((cart&&cart.items)||[]).filter(function(it){ return it.properties&&it.properties._auto_gift; })[0];
    if(!line) return;
    try{ localStorage.removeItem(NTF_PENDING_KEY); }catch(e){}
    if(line.properties['Engraving']) return;
    var np={_auto_gift:line.properties._auto_gift, 'Engraving':pend.t}; if(pend.a) np['_No refund acknowledged']='yes';
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,properties:np})})
      .then(function(){ document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); }).catch(function(){});
  }
  function seedAttrs(){
    
    if(seedInFlight) return seedInFlight;
    
    seedInFlight = fetch('/cart.js?_=' + Date.now(),{headers:{Accept:'application/json'},cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        NTF_BRACE=braceOf(cart);
        if(cart && cart.item_count) ntfApplyPending(cart);
        
        if(cart && !NTF_BRACE.any){
          var hv=cart.attributes||{}, rm={}, has=false;
          FIELDS.forEach(function(f){ if(f.group!=='brace') return; [attrKey(f),oldKey(f)].forEach(function(k){ if(hasKey(hv,k)){ rm[k]=''; has=true; } }); });
          if(has && savedThisPage){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:rm})}); }
        }
        if(!cart || !cart.item_count) return;
        
        if(savedThisPage) return;
        var have=cart.attributes||{}, missing={}, any=false, noteMoves=false;
        FIELDS.forEach(function(f){
          if(f.group==='brace' && !NTF_BRACE.any){ var bk=attrKey(f); if(hasKey(have,bk)){ missing[bk]=''; any=true; } if(hasKey(have,oldKey(f))){ missing[oldKey(f)]=''; any=true; } return; }
          var k=attrKey(f), o=oldKey(f), hadOld=hasKey(have,o);
          if(!isReal(have[k])){
            
            if(hadOld && isReal(have[o])){ missing[k]=have[o]; any=true; if(f.key==='Personal note') noteMoves=true; }
            
            else if(!String(have[k]||'').trim()){ missing[k]=GBP_NA; any=true; }
          }
          if(hadOld){ missing[o]=''; any=true; }    // '' removes the old name, in this same update
        });
        if(hasKey(have,GBP_LAYOUT_OLD)){
          
          if(noteMoves && !isReal(have[GBP_LAYOUT_KEY]) && isReal(have[GBP_LAYOUT_OLD])) missing[GBP_LAYOUT_KEY]=have[GBP_LAYOUT_OLD];
          missing[GBP_LAYOUT_OLD]=''; any=true;
        }
        if(!any) return;                       // already seeded — no request, no loop
        return fetch('/cart/update.js',{method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:missing})});
      })
      .catch(function(){ /* seeding is best-effort; never block the cart on it */ })
      .then(function(){ seedInFlight=null; });
    return seedInFlight;
  }
  
  if(document.readyState==='complete') setTimeout(seedAttrs,1200);
  else window.addEventListener('load',function(){ setTimeout(seedAttrs,1200); });
  document.addEventListener('eurus:cart:items-changed',function(){ setTimeout(seedAttrs,600); });

  
  function save(stay){
    var attrs={}, cust={}, any=false, live=liveFields(), noteText='';
    FIELDS.forEach(function(f,idx){
      
      var v=live[idx]?(vals[f.key]||'').trim():'';
      if(v){ attrs[attrKey(f)]=v; cust[f.key]=v; any=true; }
      
      else { attrs[attrKey(f)]=GBP_NA; }
      
      attrs[oldKey(f)]='';
      if(f.key==='Personal note') noteText=v;
    });
    
    var done=function(){
      updateDrawer(any);
      if(stay){
        
        showSummary(); toast(T('saved','Saved \u2713'));
        return;
      }
      close(); toast(any?T('done','Your gift is personalised \u2713'):T('closed','Closed'));
      
      returnToCart();
    };
    
    nextBtn.disabled=true; nextBtn.textContent=T('saving','Saving…');
    
    var ntfBraceText='';
    (seedInFlight || Promise.resolve())
      
      .then(function(){ try{ return noteLayout(noteText); }catch(e){ return GBP_NA; } })
      .then(function(layout){
        attrs[GBP_LAYOUT_KEY]=layout;
        attrs[GBP_LAYOUT_OLD]='';
        
        return fetch('/cart.js').then(function(r){ return r.json(); }).catch(function(){ return {}; }).then(function(c0){
          var bs=braceOf(c0), ag=bs.auto; NTF_BRACE=bs;
          ntfBraceText=(attrs['Free Bracelet side 1']||'').trim(); if(ntfBraceText===GBP_NA) ntfBraceText='';
          if(ag){ ['Free Bracelet side 1','Free Bracelet side 2','Free Bracelet side 3'].forEach(function(k){ if(k in attrs) attrs[k]=GBP_NA; }); }
          else if(!bs.any){
            ['Free Bracelet side 1','Free Bracelet side 2','Free Bracelet side 3'].forEach(function(k){ attrs[k]=''; attrs[GBP_OLD_PREFIX+k]=''; });
            try{ if(ntfBraceText) localStorage.setItem(NTF_PENDING_KEY, JSON.stringify({t:ntfBraceText, a:!!NTF_ACK})); else localStorage.removeItem(NTF_PENDING_KEY); }catch(e){}
          }
          return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attrs})});
        });
      })
      
      .then(function(r){ if(!r.ok) throw new Error('cart update '+r.status); return r.json(); })
      .then(function(cart){
        savedThisPage=true;                       // a real engraving now exists; the seeder stands down
        
        try{
          var bv=ntfBraceText;
          (cart.items||[]).forEach(function(it){
            var p=it.properties||{}; if(!p._auto_gift) return;
            if((p['Engraving']||'')===bv && (!bv || !NTF_ACK || p['_No refund acknowledged']==='yes')) return;
            var np={_auto_gift:p._auto_gift}; if(bv){ np['Engraving']=bv; if(NTF_ACK) np['_No refund acknowledged']='yes'; }
            fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:it.quantity,properties:np})})
              .then(function(){ document.dispatchEvent(new CustomEvent('eurus:cart:items-changed')); }).catch(function(){});
          });
        }catch(e){}
        var rec={ token:(cart&&cart.token)||null, at:Date.now(), vals:cust };
        try{ localStorage.setItem('gbpCustomer', JSON.stringify(rec)); }catch(e){}
        GBP_SAVED=rec; GBP_ADOPTED=true;
        nextBtn.disabled=false; nextBtn.textContent=T('save','Save personalisation');
        done();
        
        document.dispatchEvent(any ? new CustomEvent('gbp:saved',{detail:attrs})
                                   : new CustomEvent('gbp:cleared'));
        
        var braceDone=['Free Bracelet side 1','Free Bracelet side 2','Free Bracelet side 3'].some(function(k){ return attrs[k]&&attrs[k]!==GBP_NA; });
        document.querySelectorAll('[data-ntf-engrave]').forEach(function(b){ var t=b.getAttribute(braceDone?'data-done':'data-todo'); if(t) b.textContent=t; });
      })
      .catch(function(){ nextBtn.disabled=false; nextBtn.textContent=T('save','Save personalisation'); toast(T('err-save','Could not save \u2014 please try again')); });
  }

  
  var syncEdit=function(){};
  if(EDIT){
    var ep=document.getElementById('gbp-edit'); ep.style.display='block';
    var CTRLS=[{k:'x',label:'Pos X',min:0,max:100,step:.5,unit:'%'},{k:'y',label:'Pos Y',min:0,max:100,step:.5,unit:'%'},{k:'size',label:'Size',min:8,max:140,step:1},{k:'minSize',label:'Min size',min:6,max:90,step:1},{k:'rot',label:'Rotation',min:-25,max:25,step:.5,unit:'°'},{k:'ls',label:'Tracking',min:0,max:14,step:.2},{k:'mw',label:'Max width',min:5,max:95,step:1,unit:'%'},{k:'depth',label:'Depth',min:0,max:3,step:.1},{k:'opacity',label:'Opacity',min:0,max:100,step:5,unit:'%',pct:true},{k:'lines',label:'Lines',min:1,max:8,step:1,rebuild:true},{k:'max',label:'Char limit',min:1,max:1000,step:1,rebuild:true}];
    var html='<h4>Design mode — staff only</h4><p class="gbp-efield">Editing: <b id="gbp-ef">Box side</b> · drag or type</p><div class="gbp-ctrl" style="grid-template-columns:78px 40px 1fr;margin-bottom:9px"><label>Colour</label><input type="color" id="gbp-c-color"><input type="text" id="gbp-c-colorhex" placeholder="#454545"></div><div class="gbp-egrid">';
    CTRLS.forEach(function(c){ html+='<div class="gbp-ctrl"><label>'+c.label+'</label><input type="range" id="gbp-r-'+c.k+'" min="'+c.min+'" max="'+c.max+'" step="'+c.step+'"><input type="number" id="gbp-n-'+c.k+'" min="'+c.min+'" max="'+c.max+'" step="'+c.step+'"></div>'; });
    html+='</div><div class="gbp-erow"><span style="font-size:12px;color:#6b6b73">Align</span><button type="button" class="gbp-seg gbp-al" data-al="left">Left</button><button type="button" class="gbp-seg gbp-al" data-al="center">Center</button><button type="button" class="gbp-seg gbp-al" data-al="right">Right</button></div><div class="gbp-erow"><span style="font-size:12px;color:#6b6b73">Vertical</span><button type="button" class="gbp-seg gbp-va" data-va="top">Top</button><button type="button" class="gbp-seg gbp-va" data-va="middle">Middle</button><button type="button" class="gbp-seg gbp-va" data-va="bottom">Bottom</button><label style="font-size:12px;color:#6b6b73;margin-left:8px;display:flex;gap:5px;align-items:center;cursor:pointer"><input type="checkbox" id="gbp-c-bounds"> bounds</label></div><div class="gbp-erow"><button type="button" class="gbp-ebtn" id="gbp-copy">Copy settings</button><button type="button" class="gbp-ebtn sec" id="gbp-reset">Reset this field</button><span id="gbp-copied" style="font-size:12px;color:#8a6d12"></span></div>';
    ep.innerHTML=html;
    function applyKey(k,v){ var g=FIELDS[active].group, t=[]; FIELDS.forEach(function(f){ if((g&&f.group===g)||(!g&&f===FIELDS[active])) t.push(f); }); t.forEach(function(f){ f[k]=v; }); saveOverrides(); if(k==='lines'||k==='max'){ FIELDS.forEach(function(f,i){ if(t.indexOf(f)>=0) rebuildInput(i); }); } render(); }
    var color=document.getElementById('gbp-c-color'), hex=document.getElementById('gbp-c-colorhex');
    function setColor(v){ if(!/^#[0-9a-fA-F]{6}$/.test(v)) return; applyKey('color',v); color.value=v; hex.value=v; }
    color.addEventListener('input',function(){setColor(color.value);}); hex.addEventListener('input',function(){setColor(hex.value.trim());});
    CTRLS.forEach(function(c){ var r=document.getElementById('gbp-r-'+c.k), n=document.getElementById('gbp-n-'+c.k); function sv(v){ if(isNaN(v))return; v=Math.max(c.min,Math.min(c.max,v)); applyKey(c.k,c.pct?v/100:v); r.value=v; n.value=v; } r.addEventListener('input',function(){sv(parseFloat(r.value));}); n.addEventListener('input',function(){ if(n.value!=='') sv(parseFloat(n.value)); }); });
    var als=ep.querySelectorAll('.gbp-al'), vas=ep.querySelectorAll('.gbp-va');
    als.forEach(function(b){ b.addEventListener('click',function(){ applyKey('align',b.getAttribute('data-al')); als.forEach(function(x){x.classList.toggle('on',x===b);}); }); });
    vas.forEach(function(b){ b.addEventListener('click',function(){ applyKey('valign',b.getAttribute('data-va')); vas.forEach(function(x){x.classList.toggle('on',x===b);}); }); });
    document.getElementById('gbp-c-bounds').addEventListener('change',function(e){ showBounds=e.target.checked; render(); });
    document.getElementById('gbp-copy').addEventListener('click',function(){ var o={}; FIELDS.forEach(function(f){ o[f.key]={}; EDITKEYS.forEach(function(k){ o[f.key][k]=f[k]; }); }); var txt=JSON.stringify(o,null,2); (navigator.clipboard?navigator.clipboard.writeText(txt):Promise.reject()).then(function(){ document.getElementById('gbp-copied').textContent='copied ✓'; }).catch(function(){ prompt('Copy:',txt); }); console.log('[GBP settings]',txt); });
    document.getElementById('gbp-reset').addEventListener('click',function(){ try{ var o=JSON.parse(localStorage.getItem('gbpOverrides')||'{}'); delete o[FIELDS[active].key]; localStorage.setItem('gbpOverrides',JSON.stringify(o)); }catch(e){} location.reload(); });
    syncEdit=function(){ var f=FIELDS[active]; document.getElementById('gbp-ef').textContent=f.key; var cc=(f.color&&f.color[0]==='#')?f.color:'#454545'; color.value=cc; hex.value=cc; CTRLS.forEach(function(c){ var r=document.getElementById('gbp-r-'+c.k), n=document.getElementById('gbp-n-'+c.k); var cur=c.pct?Math.round((f[c.k]==null?1:f[c.k])*100):f[c.k]; r.value=cur; n.value=cur; }); als.forEach(function(x){ x.classList.toggle('on',x.getAttribute('data-al')===f.align); }); vas.forEach(function(x){ x.classList.toggle('on',x.getAttribute('data-va')===(f.valign||'middle')); }); };
  }

  var overlay=document.getElementById('gbp-overlay'), fontReady=false;
  
  var vv=window.visualViewport, vvQueued=false;
  function applyFit(){
    vvQueued=false;
    if(!vv) return;
    
    if(vv.scale>1.01){ overlay.style.removeProperty('--gbp-vh'); overlay.style.removeProperty('--gbp-vtop');
      overlay.style.removeProperty('--gbp-vbot'); return; }
    
    overlay.style.setProperty('--gbp-vh', vv.height+'px');
    overlay.style.setProperty('--gbp-vtop', (vv.offsetTop||0)+'px');
    
    var below = Math.max(0, Math.round(window.innerHeight - (vv.offsetTop||0) - vv.height));
    overlay.style.setProperty('--gbp-vbot', below+'px');
  }
  function fitViewport(){
    
    if(vvQueued) return;
    vvQueued=true;
    (window.requestAnimationFrame||setTimeout)(applyFit);
  }
  if(vv){ vv.addEventListener('resize',fitViewport); vv.addEventListener('scroll',fitViewport); }
  function ensureFont(){ if(fontReady||!document.fonts||!document.fonts.load) return; document.fonts.load('600 40px GBPMontserrat').then(function(){fontReady=true;render();}); }
  var prevOverflow=null;
  
  var pausedMedia=[], refusedMedia=[];
  function hushPage(){
    pausedMedia=[]; refusedMedia=[];
    try{
      var m=document.querySelectorAll('video,audio');
      for(var i=0;i<m.length;i++){
        if(m[i].id==='gbp-startvid') continue;
        if(!m[i].paused){ m[i].pause(); pausedMedia.push(m[i]); }
      }
    }catch(e){}
  }
  
  document.addEventListener('play',function(e){
    if(!overlay.classList.contains('gbp-open')) return;
    var t=e.target;
    if(!t||t.id==='gbp-startvid') return;
    
    try{ t.pause(); if(refusedMedia.indexOf(t)<0) refusedMedia.push(t); }catch(err){}
  },true);

  function unhushPage(){
    
    try{ pausedMedia.forEach(function(el){ el.play().catch(function(){}); }); }catch(e){}
    pausedMedia=[]; refusedMedia=[];
  }
  
  var stayHere=false;
  function returnToCart(){
    if(stayHere) return;
    
    try{ Alpine.store('xMiniCart').openCart(); }catch(e){}
  }
  var braceOnly=false;
  function open(opts){ stayHere=!!(opts&&opts.stay); braceOnly=false; viewIdx=0; startViews();
    applySteps(!!(opts&&opts.brace) || NTF_BRACE.any);
    applyStrings();
    
    var backBtn=document.getElementById('gbp-sum-back'), coBtn=document.getElementById('gbp-sum-checkout'),
        stayNote=document.getElementById('gbp-sum-stay'), contBtn=document.getElementById('gbp-sum-continue');
    if(backBtn) backBtn.hidden=stayHere;
    if(coBtn) coBtn.hidden=stayHere;
    if(stayNote) stayNote.hidden=!stayHere;
    if(contBtn) contBtn.hidden=!stayHere;
    overlay.classList.add('gbp-open'); fitViewport(); hushPage();
    warm(); warmFaces();
    if(!facesOk()){
      overlay.classList.add('gbp-fontwait');
      var lift=function(){ overlay.classList.remove('gbp-fontwait'); render(); };
      Promise.race([loadFaces(),new Promise(function(r){ setTimeout(r,1200); })]).then(lift,lift);
    }
    
    prevOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden'; ensureFont();
    
    
    var bi=-1; if(opts&&opts.brace){ for(var si=0;si<STEPS.length;si++){ if(STEPS[si].gift) bi=si; } }
    var lblP=document.querySelector('#gbp-overlay .gbp-step-label'), dots=document.getElementById('gbp-dots');
    if(lblP&&lblP._orig==null) lblP._orig=lblP.innerHTML;
    if(lblP&&bi<0) lblP.innerHTML=lblP._orig;
    if(dots) dots.style.display=(bi>-1?'none':'');
    if(bi>-1){ braceOnly=true; editOne=true; goStep(bi); if(lblP) lblP.textContent=T(STEPS[bi].t); }
    var bnote=document.getElementById('gbp-brace-note'); if(bnote){ bnote.style.display=(bi>-1)?'flex':'none'; bnote.style.color='#6f6961'; } var back0=document.getElementById('gbp-brace-ack'); if(back0) back0.checked=false; var box0=document.getElementById('gbp-box-ack'); if(box0) box0.checked=false;
    var bcl=document.getElementById('gbp-brace-clear');
    if(bcl){ var bin=document.querySelector('#gbp-stepfields input'); bcl.style.display=(bi>-1 && bin && bin.value.trim())?"block":"none";
      bcl.onclick=function(){ var i=document.querySelector('#gbp-stepfields input'); if(i){ i.value=''; i.dispatchEvent(new Event('input',{bubbles:true})); } bcl.style.display="none"; nextBtn.click(); }; }
    if(bi<0){ if(hasVals()) showSummary(); else showStart(); }
    render();
    var v=document.getElementById('gbp-startvid');
    
    if(v){ try{ v.load(); silence(v); v.play(); }catch(e){} } }
  function close(){ var bcx=document.getElementById('gbp-brace-clear'); if(bcx) bcx.style.display="none"; var bnx=document.getElementById('gbp-brace-note'); if(bnx) bnx.style.display='none'; var bxx=document.getElementById('gbp-box-note'); if(bxx) bxx.style.display='none'; overlay.classList.remove('gbp-open'); stopViews();
    
    var cv2=document.getElementById('gbp-startvid'); if(cv2){ try{ cv2.pause(); }catch(e){} }
    unhushPage();
    overlay.style.removeProperty('--gbp-vh'); overlay.style.removeProperty('--gbp-vtop');
    overlay.style.removeProperty('--gbp-vbot');
    document.documentElement.style.overflow=(prevOverflow==null?'':prevOverflow); prevOverflow=null; }
  document.getElementById('gbp-close').addEventListener('click',close);
  
  var multiTouch=false;
  overlay.addEventListener('touchstart',function(e){
    if(e.touches&&e.touches.length>1) multiTouch=true;
  },{passive:true});
  overlay.addEventListener('touchend',function(){
    setTimeout(function(){ multiTouch=false; },400);   // outlive the click the gesture emits
  },{passive:true});
  
  var downOnBackdrop=false;
  function markDown(e){ downOnBackdrop=(e.target===overlay); }
  overlay.addEventListener('pointerdown',markDown,true);
  overlay.addEventListener('mousedown',markDown,true);
  overlay.addEventListener('touchstart',markDown,{capture:true,passive:true});
  overlay.addEventListener('click',function(e){
    if(!downOnBackdrop) return;
    if(e.target!==overlay) return;
    if(multiTouch) return;
    if(vv&&vv.scale>1.01) return;
    close();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&overlay.classList.contains('gbp-open')) close(); });

  
  if(/[?&]gbp=brace(&|$)/.test(location.search)) setTimeout(function(){ open({brace:true, stay:true}); },900);
  
  (function(){ if(hasVals()) updateDrawer(true); })();
  
  (function(){
    var ev=['pointerdown','touchstart','keydown','scroll','wheel','mousemove'];
    function first(){ ev.forEach(function(n){ window.removeEventListener(n,first,true); }); warm(); }
    ev.forEach(function(n){ window.addEventListener(n,first,{capture:true,passive:true}); });
    
    
    function intent(e){ var t=e.target; if(t&&t.closest&&t.closest('.gbp-cta,[data-ntf-engrave]')) warmFaces(); }
    ['pointerdown','pointerover','focusin'].forEach(function(n){ document.addEventListener(n,intent,{capture:true,passive:true}); });
  })();
  window.GBP={open:open,close:close,edit:EDIT};
})();
